import axios from "axios";
import jwt_decode from "jwt-decode";

import { PARM } from "../../constants/parmConstants";
import { getAuthorizationInterface } from "../../static/authorization";

const parmConfig = {
  url: PARM.URL,
  autoPath: PARM.AUTO_PATH,
  permPath: PARM.PERM_PATH,
  rolesPath: PARM.ROLES_PATH,
  relationshipsPath: PARM.RELATIONSHIPS_PATH,
};

/**
 * PARM auto provision POST
 */
export const parmAutoProvision = async () => {
  try {
    const headers: any = {};
    const jwtToken = getAuthorizationInterface().getJwt();

    if (jwtToken) {
      headers.Authorization = `Bearer ${jwtToken}`;
    } else {
      return;
    }

    const response = await axios.post(parmConfig.url + parmConfig.autoPath, { jwt: jwtToken }, { headers });

    return response.data as any;
  } catch {
    return [];
  }
};

/**
 * PARM GET for User Permissions
 */
export const parmUserPermissions = async () => {
  try {
    const headers: any = {};
    const jwtToken = getAuthorizationInterface().getJwt();

    if (jwtToken) {
      headers.Authorization = `Bearer ${jwtToken}`;
    }

    // requires user_id (sub from kc jwt)
    const tokenParsed = jwt_decode(jwtToken) as any;
    const user_id = tokenParsed.sub;

    const response = await axios.get(parmConfig.url + parmConfig.permPath + user_id + "?per_page=-1", {
      headers,
    });

    sessionStorage.setItem("parm-permissions", JSON.stringify(response.data));
    return response.data as any;
  } catch {
    return [];
  }
};

/**
 * PARM GET for User Roles
 */
export const parmUserRoles = async () => {
  try {
    const headers: any = {};
    const jwtToken = getAuthorizationInterface().getJwt();

    if (jwtToken) {
      headers.Authorization = `Bearer ${jwtToken}`;
    } else {
      return;
    }
    // requires user_id (sub from kc jwt)
    const tokenParsed = jwt_decode(jwtToken) as any;
    const user_id = tokenParsed.sub;

    const response = await axios.get(parmConfig.url + parmConfig.rolesPath + user_id, {
      headers,
    });

    sessionStorage.setItem("parm-roles", JSON.stringify(response.data));
    return response.data as any;
  } catch {
    return [];
  }
};

/**
 * PARM GET for User Relationships
 */
export const parmRelationshipsPath = async () => {
  try {
    const headers: any = {};
    const jwtToken = getAuthorizationInterface().getJwt();

    if (jwtToken) {
      headers.Authorization = `Bearer ${jwtToken}`;
    }
    // requires user_id (sub from kc jwt)
    const tokenParsed = jwt_decode(jwtToken) as any;
    const user_id = tokenParsed.sub;

    const response = await axios.get(parmConfig.url + parmConfig.relationshipsPath + user_id, {
      headers,
    });

    sessionStorage.setItem("parm-relationships", response.data);
    return response.data as any;
  } catch {
    return [];
  }
};
